import styled from 'styled-components';

export const Rating = styled.div`
  width: 100%;
  display: flex;
  margin: 15px 0 30px 0;
`;
